






















import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { listLetterTemplates, LetterTemplateModel } from "@/api/LetterTemplates";
import { CollectionEventDetailsModel } from "@/api/CollectionEvents";

@Component
export default class GenerateLettersForm extends Vue {
  @Prop() readonly value?: LetterTemplateModel;
  @Prop() readonly generateLetters?: () => void;
  @Prop() readonly disabled?: boolean;
  @Prop() readonly loading?: boolean;
  @Prop() readonly collectionIssues?: CollectionEventDetailsModel[];
  @Prop() readonly buttonText?: string;

  letterTemplates: LetterTemplateModel[] = [];

  async mounted() {
    this.letterTemplates = await listLetterTemplates();
    if (this.letterTemplates.length) {
      this.onSelectedTemplateChange(this.letterTemplates[0]);
    }
  }

  onSelectedTemplateChange(newValue: LetterTemplateModel) {
    this.$emit("input", newValue);
  }

  canGenerateLetters() {
    return !this.disabled && !!this.value && !!this.collectionIssues && this.collectionIssues.length > 0;
  }
}
